import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { Link, useLocation } from 'react-router-dom';
import QuotaPopup from '../components/QuotaPopup';

const pages = ['Home', 'About Us', 'Projects', 'Blog', 'Contact Us'];

function Header() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [openPopup, setOpenPopup] = React.useState(false);
    const location = useLocation();

    const handleClosePopup = () => {
        setOpenPopup(false);
    };

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    return (
        <AppBar
            position="static"
            sx={{
                backgroundColor: 'white', // Replace with the color you want
                boxShadow: 'none',
                paddingX: { xs: 0, md: '110px' },
            }}
        >
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Typography
                        variant="h6"
                        noWrap
                        component={Link}
                        to="/"
                        sx={{
                            mr: 2,
                            display: { xs: 'none', md: 'flex' },
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 700,
                            letterSpacing: '.08rem',
                            color: 'black',
                            textDecoration: 'none',
                        }}
                    >
                        AL AMINA <Typography component="span" variant="subtitle1" sx={{ fontStyle: 'italic', fontSize: '0.7em', ml: 1, mt:0.55 }}>Stucco</Typography>
                    </Typography>

                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' }, justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography
                            variant="h6"
                            noWrap
                            component={Link}
                            to="/"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 700,
                                letterSpacing: '.1rem',
                                color: 'black',
                                textDecoration: 'none',
                            }}
                        >
                            AL AMINA <Typography component="span" variant="subtitle1" sx={{ fontStyle: 'italic', fontSize: '0.7em', ml: 0.5, mt:0.2 }}>Stucco</Typography>
                        </Typography>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="black"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            {pages.map((page) => (
                                <MenuItem key={page} onClick={handleCloseNavMenu} sx={{ fontFamily: 'Poppins, sans-serif' }}>
                                    <Link to={`/${page.toLowerCase().replace(/ /g, '')}`} style={{ color: 'black', textDecoration: 'none' }}>
                                        <Typography textAlign="center" sx={{ textTransform: 'none' }}>{page}</Typography>
                                    </Link>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>

                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, marginLeft: { md: '6rem' }, justifyContent: { md: 'space-between' } }}>
                        {pages.map((page) => (
                            <Button
                                key={page}
                                onClick={handleCloseNavMenu}
                                sx={{
                                    my: 2,
                                    backgroundColor: (location.pathname === `/${page.toLowerCase().replace(/ /g, '')}` || (page === 'Home' && location.pathname === '/')) ? 'rgba(0, 0, 0, 0.08)' : 'transparent',
                                    color: 'black',
                                    display: 'block',
                                    fontFamily: 'Poppins, sans-serif',
                                    '&:hover': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.08)',
                                    }
                                }}
                            >
                                <Link to={`/${page.toLowerCase().replace(/ /g, '')}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                                    <Typography sx={{ fontSize: '1rem', fontWeight: '600' }}>{page}</Typography>
                                </Link>
                            </Button>
                        ))}
                    </Box>
                </Toolbar>
            </Container>
            <QuotaPopup open={openPopup} handleClose={handleClosePopup} />
        </AppBar>
    );
}

export default Header;
